import { Search } from '../../model/search';

export enum SearchActionTypes {
  SAVE_SEARCH = '@@search/SAVE_SEARCH',
}

export interface SearchState {
  search?: Search;
  test?: boolean;
}
